export const getAuthConfig = (keycloak: any) => {
    const token = keycloak.token();
    const headers = {
        Authorization: `Bearer ${token}`
    };
    return headers;
}